import { observable, action, makeObservable, computed, toJS } from "mobx";

export class NotificationStore {
  notifications: any[] = [];

  constructor() {
    makeObservable(this, {
      notifications: observable,
      addNotification: action,
      getNotificationsArray: computed,
    });
  }

  addNotification(notification: any) {
    this.notifications.push(notification);
  }

  removeNotification() {
    this.notifications.shift();
  }

  // Method to get notifications as a regular array
  get getNotificationsArray() {
    return toJS(this.notifications || []);
  }
}

const notificationStore = new NotificationStore();

export default notificationStore;
